import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, AlertCircle, CheckCircle } from 'lucide-react';
import BrandMark from '../components/BrandMark';
import { toast } from 'react-toastify';
import api from '../services/api';
import '../styles/auth.css';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Por favor, informe seu e-mail');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/auth/forgot-password', { email });
      
      setSent(true);
      toast.success(response.data.message);
      
    } catch (error) {
      const message = error.response?.data?.error || 'Erro ao enviar e-mail de recuperação';
      toast.error(message);
      console.error('Erro ao solicitar recuperação:', error);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-icon success">
              <CheckCircle size={32} />
            </div>
            <h1>E-mail Enviado!</h1>
            <p>Verifique sua caixa de entrada</p>
          </div>

          <div className="success-message">
            <p>
              Se o e-mail <strong>{email}</strong> estiver cadastrado em nosso sistema, 
              você receberá instruções para redefinir sua senha.
            </p>
            
            <div className="info-box">
              <AlertCircle size={16} />
              <div>
                <p><strong>Não recebeu o e-mail?</strong></p>
                <ul>
                  <li>Verifique sua pasta de spam/lixo eletrônico</li>
                  <li>O link expira em 1 hora</li>
                  <li>Você pode solicitar um novo link a qualquer momento</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="auth-actions">
            <button 
              onClick={() => setSent(false)}
              className="btn btn-secondary"
            >
              Enviar Novamente
            </button>
            
            <Link to="/login" className="btn btn-primary">
              <ArrowLeft size={18} />
              Voltar ao Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <BrandMark tone="light" height={56} className="mx-auto mb-6 block" decorative />
          <h1>Recuperar Senha</h1>
          <p>Digite seu e-mail para receber o link de recuperação seguro</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <div className="input-group">
              <Mail size={18} />
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Digite seu e-mail"
                required
                disabled={loading}
              />
            </div>
          </div>

          <button 
            type="submit" 
            className="btn btn-primary btn-block"
            disabled={loading}
          >
            {loading ? 'Enviando...' : 'Enviar Link de Recuperação'}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/login" className="auth-link">
            <ArrowLeft size={16} />
            Voltar ao Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage; 